import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from "../elements/CustomButton/CustomButton";
import { useSnackbar } from "../SnackbarContext";
import axiosInstance from "../../configuration/request";
import CustomAutocomplete from '../elements/CustomeAutocomplete';
import { modules } from '../../constants/rbacManagement';

function CreatePermission({ onClose, mode, permissionDetails, onSubmit }) {
     const showSnackbar = useSnackbar();
  const [formData, setFormData] = useState({
    module: null,
    permissions: [],
  });

  useEffect(() => {
    if (mode === 'edit' && permissionDetails) {
      setFormData({
        module: {
          label: permissionDetails.resource,
          value: permissionDetails.resource,
        },
        permissions: Array.isArray(permissionDetails.action) ? permissionDetails.action : [],
      });
    } else {
      setFormData({
        module: null,
        permissions: [],
      });
    }
  }, [mode, permissionDetails]);

const handleSubmit = () => {
  if (!formData.module || !formData.permissions.length) return;

  const payload = {
    resource: formData.module.value,
    action: formData.permissions,
  };

  const isEdit = mode === "edit";

  const url = isEdit
    ? `auth/rbac/update-permission/${permissionDetails?.id}`
    : `auth/rbac/create-permission`;

  const requestMethod = isEdit ? axiosInstance.patch : axiosInstance.post;

  requestMethod(url, payload)
    .then(() => {
       showSnackbar(`Permission ${isEdit ? 'updated' : 'created'} successfully!`, "success");
      onSubmit();
    })
     .catch((err) => {
      if(err.response.data.message){
        showSnackbar(err.response.data.message, "error");
      }
      else{
        showSnackbar("Something went wrong!", "error");
      }
        
      });
};


  const handleSelect = (selectedValue) => {
    setFormData((prev) => ({
      ...prev,
      module: selectedValue || null,
    }));
  };

const handlePermissionToggle = (label, checked) => {
  setFormData((prev) => {
    const labelLower = label.toLowerCase();
    const existing = prev.permissions.some(
      (perm) => perm.toLowerCase() === labelLower
    );

    let updatedPermissions;
    if (checked) {
      updatedPermissions = existing
        ? prev.permissions
        : [...prev.permissions, label];
    } else {
      updatedPermissions = prev.permissions.filter(
        (perm) => perm.toLowerCase() !== labelLower
      );
    }

    return { ...prev, permissions: updatedPermissions };
  });
};


  return (
    <div className="pt-6 px-10">
      <div className="flex justify-between mb-6">
        <div className="text-lg font-[500]">
          {mode === 'edit' ? 'Edit Permission' : 'Create Permission'}
        </div>
        <button
          className="text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="flex flex-col my-4 w-full justify-center items-center">
        <div className="flex flex-wrap items-end gap-6 mb-8 w-full">
          <div className="w-full max-w-[350px] mr-4">
            <CustomAutocomplete
              label="Resource/Module"
              value={formData.module}
              onChange={handleSelect}
              options={modules}
              multiple
            />
          </div>

          <div className="flex flex-col">
            <label className="font-[500] text-base mb-2">Actions</label>
            <div className="flex gap-4 flex-wrap">
              {['View', 'Edit', 'Write', 'Delete'].map((label) => (
                <label
                  key={label}
                  className="flex items-center gap-2 text-sm text-gray-700"
                >
                  <input
                    type="checkbox"
                    checked={Array.isArray(formData.permissions) && formData.permissions.includes(label)}
                    onChange={(e) => handlePermissionToggle(label, e.target.checked)}
                    className="w-6 h-6 accent-[#3587B8]"
                  />
                  {label}
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center mt-8 mb-4 gap-3">
          <CustomButton
            onClick={onClose}
            customeClass="primary-custom-button w-full sm:w-[150px] h-[40px]"
          >
            Cancel
          </CustomButton>
          <CustomButton
            onClick={handleSubmit}
            customeClass="gradient-button w-full sm:w-[150px] h-[40px]"
            disabled={!formData.module || formData.permissions.length === 0}
          >
            {mode === 'edit' ? 'Update' : 'Create'}
          </CustomButton>
        </div>
      </div>
    </div>
  );
}

export default CreatePermission;
